import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { LVN_PROTOCOL_ITEMS } from './lvnProtocolConstants';

const LvnProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="LVN"
            title="LVN JOB DESCRIPTION"
            items={LVN_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default LvnProtocol;
